import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import GameTypeIcon from  '../../assets/images/Strategy Game.png'
import { createGameTypeService, getGameTypeService, updateGameTypeService } from '../../services/gametype.service';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import SharePercent from './SharePercent';

const GameType = () => {

    const [showEdit, setShowEdit] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [gameTypeData, setGameTypeData] = useState([]);  //Get GameTypeData from API  //Get UserData from API
    const [inputModal, setInputModal] = useState({});  //for edit modal
    const [errors, setErrors] = useState({});  //for validation
    const [inputData, setInputData] = useState({
        gameType: ''
      });   //for new GameType input

    const dispatch = useDispatch();

    //newGameType input Reset
    const formReset = () => {
        setShowEdit(false);
        setInputData({
            gameType: ''
          });
          setErrors({});
      }

    //editGameType modal show/hide
    const handleEditClick = (item) => {
      setShowEdit(false);
        setIsEdit(!isEdit);
        setInputModal(item);
    }

    const handleAdjustClick = (item) => {
      setShowEdit(!showEdit);
      setIsEdit(false);
      setInputModal(item);
    }

    const handleCloseModal = () => {
        setIsEdit(false);
    }

    //newGameType form submit and validation
    let handleSubmit = (event) => {
      event.preventDefault();
      const validateErrors = validate();
      if(Object.keys(validateErrors).length === 0) {
        createAction();
      }
      else {
        setErrors(validateErrors);
      }
    }

    //editGameType modal submit and validation
    let handleSubmitModal = (event) => {
      event.preventDefault();
      const validateErrors = validate();

      if(Object.keys(validateErrors).length === 0) {
        createAction();
      }
      else {
        setErrors(validateErrors);
      }
    }


    //validation for newGameType and editGameType input
    const validate = () => {
        let errors = {};
        if(showEdit) {
            if(!inputModal) {
                errors.gameType = 'Business Type is required in Modal';
            }
        }
        else {
            if(!inputData.gameType) {
                errors.gameType = 'Business Type is required';
            }
        }

        return errors;
      }


     // Get GameTypeData from API
    const getGameTypeData = async (signal) => {
        dispatch(setIsLoading(true))

        try {
            const result = await getGameTypeService(signal);
            if(result.data) {
                setGameTypeData(result.data)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
        dispatch(setIsLoading(false))
        }
    }


    //CREATE GAME TYPE AND UPDATE GAME TYPE to API
    const createAction = async () => {
      dispatch(setIsLoading(true))

      try {
        let result;
        if(showEdit) {
          result = await updateGameTypeService({
            ...inputModal
            // ,permission
          });

        } else {
          result = await createGameTypeService({
            ...inputData
          // ,permission
        })}

        if(result.data) {
          if(showEdit) {
            setGameTypeData(gameTypeData.map(obj => obj.gameTypeId === result.data.gameTypeId ?
                result.data
               : obj));
          }
          else
          {
            gameTypeData.push(result.data);
          }
          formReset();
        }
      } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
       dispatch(setIsLoading(false))
      }
    }

    // load gameType and reload gameType when form submit [useEffect]
    useEffect(() => {
      const controller = new AbortController();
      const signal = controller.signal;
      getGameTypeData(signal);

      return () => {
          controller.abort();
      }
    },[]);

    return (
        <>
            <div className='flex justify-center w-full'>
                <div className='h-[90vh] w-full md:w-[95%] text-sm'>

                    {/* Game Type Header */}
                    <div className='py-4 pl-1 flex gap-2'>
                        <img src={GameTypeIcon} alt="" />
                        <span className='text-fgColor font-semibold'>Business Type</span>
                    </div>

                    {/* Create new gameType input including formsubmit */}
                    <div className='w-full h-[85%] bg-rectangle rounded-sm pb-10'>
                        <form onSubmit={handleSubmit}
                         className='flex items-center h-20 w-[93%] pl-5 m-auto border-b-2 border-borderColor gap-2'>
                           <div>
                            <input type="text" className='w-[210px] bg-textbgcol px-3 py-2 rounded-sm font-semibold mt-3 outline-none' placeholder='Business' name='gameType'
                                onChange={(e) => setInputData({...inputData, gameType: e.target.value})} value={inputData.gameType}
                                />

                                {errors.gameType && !showEdit && <p className='text-red text-xs font-bold'>{errors.gameType}</p>}
                           </div>

                            <button type="submit" className='bg-primary w-[110px] px-3 py-2 text-center font-semibold text-white rounded-md mt-3 cursor-pointer'>Save</button>
                        </form>

                        {/* GameType Table */}
                        <div className="h-[85%] overflow-y-auto">
                            {gameTypeData && (
                              <table className='w-full md:w-[85%] m-auto mt-5 text-fgColor overflow-y-auto'>
                                <thead>
                                    <tr className='border-b-2 border-borderColor bg-slate-50 text-black font-semibold m-auto'>
                                        <th className='w-[7%] text-left px-5 md:px-7 py-5'>No.</th>
                                        <th className='w-[28%] text-left px-5 md:px-7 py-5'>Business Type</th>
                                        <th className='w-[20%] text-left px-5 md:px-7 py-5'>Status</th>
                                        <th className='w-[5%] text-center px-5 md:px-7 py-5'>Action</th>
                                    </tr>
                                </thead>
                                <tbody className=''>
                                    {gameTypeData.map((item, index) => (
                                        <tr className='border-b-2 border-borderColor' key={index}>
                                            <td className='text-left px-5 md:px-7 py-3'>{index + 1}</td>
                                            <td className='text-left px-5 md:px-7'>{item.gameType}</td>
                                            <td className={`text-left px-5 md:px-7 ${!item.status ? 'text-slate-300' : '' }`}>{item.status ? 'Active' : 'NoActive'}</td>
                                            <td className='flex items-center justify-center gap-1 h-12 px-5 md:px-7'>
                                                <button className='bg-primary px-7 py-2 text-white rounded-md font-semibold cursor-pointer' onClick={() => handleEditClick(item)}>Edit</button>
                                                <button className='bg-primary px-5 py-2 text-white rounded-md font-semibold cursor-pointer' onClick={() => handleAdjustClick(item)}>Adjust</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            )}
                        </div>

                        {/* Edit gameType input including formsubmit */}
                        <SharePercent
                          showEdit={showEdit}
                          setShowEdit={setShowEdit}
                          inputModal={inputModal}
                          setInputModal={setInputModal}
                          handleSubmitModal={handleSubmitModal}
                          errors={errors}
                        />

                        { isEdit && (
                            <div className='fixed inset-0 bg-textcol bg-opacity-30 backdrop-blur-sm flex justify-center items-center'>
                              <form className='flex flex-col items-center justify-center bg-white w-96 h-56 rounded-md'>
                                  <div className='mb-5'>
                                    <input
                                        type="text"
                                        onChange={(e) => setInputModal({...inputModal, gameType: e.target.value})}
                                        value={inputModal.gameType}
                                        className='w-[210px] bg-textbgcol px-3 py-2 rounded-sm font-semibold mt-8 outline-none'
                                    />
                                    {errors.gameType && showEdit && <p className='text-red text-xs font-bold'>{errors.gameType}</p>}
                                    <div className='flex gap-2 ml-2 mt-3 select-none'>
                                        <input
                                            type="checkbox"
                                            checked={inputModal.status}
                                            onChange={(e) => setInputModal({...inputModal, status: e.target.checked})}
                                            name='chkStatus'
                                            className='cursor-pointer'
                                        />
                                        <label htmlFor='chkStatus'>{inputModal.status ? 'Active' : 'NoActive'}</label>
                                    </div>
                                  </div>


                                  <div className="flex justify-end items-center w-[80%] h-[35px] mt-2 select-none">
                                      <button className="px-7 py-2 mr-2 text-white bg-primary rounded-md cursor-pointer" type='submit'
                                      >Save</button>
                                      <button className="px-7 py-2 mr-2 text-white bg-primary rounded-md cursor-pointer" onClick={handleCloseModal}>Cancel</button>
                                  </div>
                              </form>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default GameType
